module.exports = __webpack_public_path__ + "media/components/app-store/static/s4-c34bdf29ba0cc9897a9ebe3bfcbdd491.png";